/* CAFFREY Revive Color Finisher Spray — page behaviour (launch build, Claude Code, 2026-10-08).
   <cf-rf-page>      Finish buttons -> the main form's hidden [name=id] (+ a bubbling change event for the kit sticky bar and
                     Shopify's Shop Pay button), legend, price, hero picture (the real Matte or Shiny can, cross-fade), ?variant=.
                     Nothing is preselected (the wrong sheen is the top regret): Add to cart, Shop Pay (a transparent guard over
                     Shopify's greyed button) and the sticky bar show "Choose your finish first." under the legend and bring the
                     legend, the message and the buttons into view. Zoom: the native catalog photos in a dialog.
   <cf-rf-carousel>  uses carousel: labels + arrows over a scroll-snap track (tap or swipe; no autoplay, no counter digits).
   Routine card (kit): the Revive Leather Paint select starts on "Choose a shade" (never a guessed shade).
   Respects prefers-reduced-motion. No dependencies; Dawn's <product-form> does the AJAX add and the cart notification. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behaviour = function () { return reduced ? 'auto' : 'smooth'; };
  var arr = function (list) { return Array.prototype.slice.call(list || []); };
  var designMode = function () { return !!(window.Shopify && window.Shopify.designMode); };

  if (!customElements.get('cf-rf-page')) {
    class CfRfPage extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var self = this;
        this.form = document.getElementById(this.dataset.form);
        this.idInput = this.form ? this.form.querySelector('[data-cf-rf-id]') : null;
        this.add = this.form ? this.form.querySelector('[data-cf-atc]') : null;
        this.addLabel = this.add ? this.add.querySelector('span') : null;
        this.radios = arr(this.querySelectorAll('[data-cf-rf-finish]'));
        this.box = this.querySelector('[data-cf-rf-finishes]');
        this.error = this.querySelector('[data-cf-rf-error]');
        this.legend = this.querySelector('[data-cf-rf-legend]');
        this.selectedEl = this.querySelector('[data-cf-rf-selected]');
        this.prices = arr(this.querySelectorAll('[data-cf-rf-price]'));
        this.hero = this.querySelector('[data-cf-rf-hero]');
        this.heroSource = this.querySelector('[data-cf-rf-hero-source]');
        this.guard = this.querySelector('[data-cf-rf-pay-guard]');
        this.zoom();
        if (!this.form || !this.idInput || !this.add || !this.box) return;
        this.idInput.disabled = false;
        this.box.addEventListener('change', function (e) {
          if (e.target.matches('[data-cf-rf-finish]')) self.choose(e.target, true);
        });
        this.box.addEventListener('pointerdown', function (e) {
          var r = e.target.closest('.cf-rf-finish');
          var input = r ? r.querySelector('[data-cf-rf-finish]') : null;
          if (input && !input.disabled) self.preload(input);
        }, { passive: true });
        /* Capture at the document so this runs before Dawn's <product-form> submit handler on the form itself. */
        document.addEventListener('submit', function (e) { if (e.target === self.form) self.validate(e); }, true);
        if (this.guard) this.guard.addEventListener('click', function (e) { e.preventDefault(); self.ask(); });
        /* Keyboard users can still reach Shopify's "More payment options" link under the guard: with no finish chosen, a
           click anywhere in the payment block asks for a finish instead. */
        var pay = this.querySelector('[data-cf-rf-pay]');
        if (pay) {
          pay.addEventListener('click', function (e) {
            if (self.selected() || (e.target.closest && e.target.closest('[data-cf-rf-pay-guard]'))) return;
            e.preventDefault();
            e.stopPropagation();
            self.ask();
          }, true);
        }
        window.addEventListener('pageshow', function () { self.sync(); });
        this.sync();
        this.watchSticky();
        this.dataset.ready = 'true';
      }

      selected() {
        for (var i = 0; i < this.radios.length; i++) if (this.radios[i].checked && !this.radios[i].disabled) return this.radios[i];
        return null;
      }

      anyAvailable() { return this.radios.some(function (r) { return !r.disabled; }); }

      firstEnabled() {
        for (var i = 0; i < this.radios.length; i++) if (!this.radios[i].disabled) return this.radios[i];
        return null;
      }

      sync() { this.choose(this.selected(), false); }

      choose(radio, user) {
        var id = radio ? radio.value : '';
        if (this.idInput.value !== id) {
          this.idInput.value = id;
          this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (this.legend) this.legend.textContent = radio ? this.dataset.finish : this.dataset.choose;
        if (this.selectedEl) this.selectedEl.textContent = radio ? radio.getAttribute('data-label') : '';
        if (radio && radio.getAttribute('data-price')) {
          var price = radio.getAttribute('data-price');
          this.prices.forEach(function (p) { if (p.textContent !== price) p.textContent = price; });
        }
        var ok = radio ? radio.getAttribute('data-available') === 'true' : this.anyAvailable();
        this.add.disabled = !ok;
        if (this.addLabel) this.addLabel.textContent = ok ? this.dataset.add : this.dataset.soldOut;
        if (this.guard) this.guard.hidden = !!radio || !this.anyAvailable();
        if (radio) {
          this.clearError();
          this.showCan(radio, user);
        }
        if (user && radio && !designMode() && window.history && history.replaceState) {
          try {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', radio.value);
            history.replaceState(history.state, '', u.toString());
          } catch (err) { /* ignore */ }
        }
        this.patchSticky();
      }

      /* Warm the chosen can's picture on pointerdown, so the swap after the click is instant. */
      preload(radio) {
        if (radio._pre || !radio.dataset.phone) return;
        var desk = window.matchMedia && window.matchMedia('(min-width: 750px)').matches;
        var im = new Image();
        im.sizes = desk ? (this.heroSource ? this.heroSource.getAttribute('sizes') : '50vw') : '100vw';
        im.srcset = desk ? radio.dataset.desk : radio.dataset.phone;
        radio._pre = im;
      }

      showCan(radio, user) {
        var img = this.hero;
        if (!img || !radio.dataset.phone) return;
        if (img.getAttribute('data-variant') === radio.value) return;
        img.setAttribute('data-variant', radio.value);
        var src = this.heroSource;
        var apply = function () {
          if (img.getAttribute('data-variant') !== radio.value) return;
          if (src && radio.dataset.desk) src.srcset = radio.dataset.desk;
          img.srcset = radio.dataset.phone;
          img.src = radio.dataset.src;
          img.alt = radio.dataset.alt || radio.getAttribute('data-label');
        };
        if (reduced || !user) { apply(); return; }
        this.preload(radio);
        img.classList.add('is-swapping');
        var done = false;
        var finish = function () { if (done) return; done = true; img.classList.remove('is-swapping'); };
        img.addEventListener('load', finish, { once: true });
        setTimeout(apply, 140);
        setTimeout(finish, 900);
      }

      validate(e) {
        if (this.selected()) { this.clearError(); return; }
        e.preventDefault();
        e.stopImmediatePropagation();
        this.ask();
      }

      /* "Choose your finish first." sits between the legend and the buttons. A repeated tap re-announces it (role=alert) and
         replays a short fade so the shopper sees the page answered. */
      ask() {
        var sticky = document.querySelector('cf-kit-sticky');
        if (sticky && typeof sticky.done === 'function') sticky.done();
        if (!this.anyAvailable()) return;
        var msg = this.dataset.chooseFirst;
        var el = this.error;
        if (el) {
          var again = !el.hidden && el.textContent === msg;
          el.hidden = false;
          el.classList.remove('is-on');
          void el.offsetWidth;
          el.classList.add('is-on');
          if (again) {
            el.textContent = ' ';
            setTimeout(function () { el.textContent = msg; }, 80);
          } else {
            el.textContent = msg;
          }
        }
        this.box.setAttribute('aria-invalid', 'true');
        this.reveal();
        var first = this.firstEnabled();
        if (first) { try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); } }
      }

      /* Bring the legend, the message and both buttons into view together, under the store's sticky-on-scroll-up header and
         above a short bottom overlay (Klaviyo teaser: --cf-bottom-overlay from the kit). The sticky bar hides by itself once
         Add to cart is back in view. */
      reveal() {
        var box = this.box.closest('fieldset') || this.box;
        var r = box.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var hdr = document.querySelector('sticky-header');
        var head = hdr ? Math.min(Math.round(hdr.getBoundingClientRect().height), 160) : 0;
        var over = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cf-bottom-overlay')) || 0;
        var top = head + 12;
        var bottom = Math.min(over, 160) + 12;
        if (r.top >= top && r.bottom <= vh - bottom) return;
        window.scrollTo({ top: Math.max(0, Math.round(window.pageYOffset + r.top - top)), behavior: behaviour() });
      }

      clearError() {
        if (this.error) { this.error.textContent = ''; this.error.hidden = true; this.error.classList.remove('is-on'); }
        if (this.box) this.box.removeAttribute('aria-invalid');
      }

      /* The hero opens the native 1080 px catalog photos (the chosen finish first in view). Without <dialog> the link simply
         opens the photo. */
      zoom() {
        var self = this;
        var link = this.querySelector('[data-cf-rf-zoom]');
        var dlg = this.querySelector('[data-cf-rf-zoom-dialog]');
        if (!link || !dlg || typeof dlg.showModal !== 'function') return;
        var scroller = dlg.querySelector('.cf-rf-zoom__in');
        link.addEventListener('click', function (e) {
          if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button !== 0) return;
          e.preventDefault();
          dlg.showModal();
          var sel = self.selected();
          var fig = sel ? dlg.querySelector('[data-zoom-variant="' + sel.value + '"]') : null;
          if (scroller) scroller.scrollTop = fig ? Math.max(0, fig.offsetTop - 56) : 0;
        });
        dlg.addEventListener('click', function (e) {
          if (e.target === dlg || (e.target.closest && e.target.closest('[data-cf-rf-zoom-close]'))) dlg.close();
        });
        dlg.addEventListener('close', function () { try { link.focus({ preventScroll: true }); } catch (err) { /* ignore */ } });
      }

      /* The kit sticky bar treats "no variant" as unavailable. With nothing preselected it shows "Choose your finish" and keeps
         an active "Add to cart" that presses the main button, whose check leads the shopper to the finish buttons. Once a finish
         is chosen it shows the page label ("Gloss (Shiny)") instead of the bare variant title. */
      watchSticky() {
        var self = this;
        var tries = 0;
        var attach = function () {
          var st = document.querySelector('cf-kit-sticky');
          if (!st) { if (++tries < 20) setTimeout(attach, 250); return; }
          if (self._stickyObs) return;
          self._sticky = st;
          self._stickyObs = new MutationObserver(function () { self.patchSticky(); });
          self._stickyObs.observe(st, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
          self.patchSticky();
        };
        attach();
      }

      patchSticky() {
        var st = this._sticky;
        if (!st) return;
        var btn = st.querySelector('[data-cf-sticky-atc]');
        var label = btn ? btn.querySelector('span') : null;
        var v = st.querySelector('[data-cf-sticky-variant]');
        var sel = this.selected();
        if (!sel) {
          if (!this.anyAvailable()) return;
          if (btn && btn.disabled) btn.disabled = false;
          if (label && label.textContent !== this.dataset.add) label.textContent = this.dataset.add;
          if (v && v.textContent !== this.dataset.choose) v.textContent = this.dataset.choose;
        } else if (v && v.textContent !== sel.getAttribute('data-label')) {
          v.textContent = sel.getAttribute('data-label');
        }
      }
    }
    customElements.define('cf-rf-page', CfRfPage);
  }

  if (!customElements.get('cf-rf-carousel')) {
    class CfRfCarousel extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var self = this;
        this.track = this.querySelector('[data-cf-rf-track]');
        if (!this.track) return;
        this.slides = arr(this.track.children);
        this.tabs = arr(this.querySelectorAll('[data-cf-rf-go]'));
        this.prev = this.querySelector('[data-cf-rf-prev]');
        this.next = this.querySelector('[data-cf-rf-next]');
        this.index = 0;
        this.tabs.forEach(function (t) {
          t.addEventListener('click', function () { self.go(Number(t.getAttribute('data-cf-rf-go'))); });
        });
        if (this.prev) this.prev.addEventListener('click', function () { self.go(self.index - 1); });
        if (this.next) this.next.addEventListener('click', function () { self.go(self.index + 1); });
        var raf = null;
        this.track.addEventListener('scroll', function () {
          if (raf) return;
          raf = requestAnimationFrame(function () { raf = null; self.sync(); });
        }, { passive: true });
        this.track.addEventListener('keydown', function (e) {
          if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(e.key) < 0) return;
          e.preventDefault();
          var last = self.slides.length - 1;
          self.go(e.key === 'Home' ? 0 : e.key === 'End' ? last : self.index + (e.key === 'ArrowRight' ? 1 : -1));
        });
        if (window.ResizeObserver) {
          this.ro = new ResizeObserver(function () {
            self.track.scrollTo({ left: self.index * self.track.clientWidth, behavior: 'auto' });
          });
          this.ro.observe(this.track);
        }
        this.mark(0);
      }
      disconnectedCallback() { if (this.ro) this.ro.disconnect(); }
      go(i) {
        i = Math.max(0, Math.min(this.slides.length - 1, i));
        this.track.scrollTo({ left: i * this.track.clientWidth, behavior: behaviour() });
        this.mark(i);
      }
      sync() { this.mark(Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth))); }
      mark(i) {
        this.index = i;
        this.tabs.forEach(function (t) { t.setAttribute('aria-pressed', String(Number(t.getAttribute('data-cf-rf-go')) === i)); });
        if (this.prev) this.prev.disabled = i <= 0;
        if (this.next) this.next.disabled = i >= this.slides.length - 1;
      }
    }
    customElements.define('cf-rf-carousel', CfRfCarousel);
  }

  /* Routine card (kit): never a guessed shade. The Revive Leather Paint select starts on "Choose a shade"; Add to cart without a
     shade shows "Choose a shade first." in the card's own error line and sends nothing. */
  function routineShade() {
    var page = document.querySelector('cf-rf-page');
    if (!page) return;
    var text = page.dataset.chooseShade;
    var first = page.dataset.chooseShadeFirst;
    if (!text) return;
    arr(document.querySelectorAll('.cf-kit-routine .cf-kit-card')).forEach(function (card) {
      var link = card.querySelector('.cf-kit-card__title a');
      if (!link || (link.getAttribute('href') || '').indexOf('/products/caffrey-revive-leather-paint') < 0) return;
      /* The kit's sizes says 300px, but one card renders ~388px wide on desktop: ask for the matching file (lazy, not loaded yet). */
      var img = card.querySelector('.cf-kit-card__media img');
      if (img && !img.complete) img.sizes = '(min-width: 990px) 400px, (min-width: 750px) 45vw, 112px';
      var sel = card.querySelector('select[name="id"]');
      if (!sel || sel.querySelector('option[value=""]')) return;
      var opt = document.createElement('option');
      opt.value = '';
      opt.textContent = text;
      opt.disabled = true;
      sel.insertBefore(opt, sel.firstChild);
      opt.selected = true;
      sel.value = '';
      var form = sel.form;
      var pf = card.querySelector('product-form');
      var wrap = pf ? pf.querySelector('.product-form__error-message-wrapper') : null;
      var msg = wrap ? wrap.querySelector('.product-form__error-message') : null;
      sel.addEventListener('change', function () {
        if (sel.value && wrap) { wrap.hidden = true; if (msg) msg.textContent = ''; }
      });
      document.addEventListener('submit', function (e) {
        if (e.target !== form || sel.value) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (wrap && msg && first) { msg.textContent = first; wrap.hidden = false; }
        try { sel.focus(); } catch (err) { /* ignore */ }
      }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', routineShade, { once: true });
  else routineShade();
})();
